import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import CustomizedTimeline from "../components/CustomizedTimeline";
import AccordionComponent from "../components/Accordion";
import LandingAnalyticsSection from "../components/LandingAnalyticsSection";
import LandingProductsSection from "../components/LandingProductsSection";
import LandingProductDetailsSection from "../components/LandingProductDetailsSection";
import LandingCreationSection from "../components/LandingCreationSection";
import LandingMotivationSection from "../components/LandingMotivationSection";
import LandingSectionHeader from "../components/LandingSectionHeader";
import {
  MessengerBrandInline,
  MessengerBrandStack,
} from "../components/MessengerBrandIcons";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import "./index.css";

const AUDIENCE = {
  icon: <BusinessCenterOutlinedIcon />,
  title: "Для тех, кто хочет обучать быстрее и современнее",
  intro:
    "MOGAME — для компаний, которые идут в ногу со временем: хотят обучать проще, поддерживать сотрудников без лишней бюрократии и давать команде инструменты, которые реально используют каждый день.",
  subtitle: "Платформа будет интересна, если вы:",
  points: [
    "HR-специалист или HR-директор",
    "Занимаетесь обучением и развитием сотрудников (L&D)",
    "Отвечаете за онбординг и адаптацию новичков",
    "Руководитель отдела, который хочет стандартизировать процессы",
    "Владелец или управляющий бизнеса, который инвестирует в команду",
    "Работаете в ритейле, HoReCa или сервисе с линейным персоналом",
    "Руководите отделом продаж или клиентского сервиса",
    "Наставник или тимлид, который устал отвечать на одни и те же вопросы",
  ],
};

const BENEFITS = [
  {
    icon: <AccountTreeOutlinedIcon />,
    title: "Живое обучение, не запись",
    desc: "Сотрудник принимает решения — и видит разный результат. Это вовлекает сильнее, чем линейное видео, которое перематывают на третьей минуте.",
  },
  {
    icon: <PlayCircleOutlineIcon />,
    title: "Подсказка вместо забытых инструкций",
    desc: "Инструкцию легко забыть — в боте подсказка всегда под рукой. База знаний снимает повторяющиеся вопросы без поиска в чатах и ожидания наставника.",
  },
  {
    icon: <TrendingUpOutlinedIcon />,
    title: "Прокачка навыков и мотивация",
    desc: "Тренажёр отрабатывает знания на практике. Можно поощрять команду: ачивки, рейтинг, бонусы за лучший результат.",
  },
  {
    icon: <GroupsOutlinedIcon />,
    title: "Там, где уже работает команда",
    desc: "Telegram и MAX — без новых приложений, регистраций и долгой настройки LMS.",
  },
  {
    icon: <SavingsOutlinedIcon />,
    title: "Видео и текст в одном месте",
    desc: "Объясняйте как удобно: коротким текстом или видео — формат подбираете вы под каждую задачу.",
  },
];

const OUTCOMES = [
  {
    icon: <SpeedOutlinedIcon />,
    title: "Быстрее адаптация",
    desc: "Новичок проходит программу в своём темпе и быстрее выходит на рабочие задачи.",
  },
  {
    icon: <SavingsOutlinedIcon />,
    title: "Меньше нагрузки на HR",
    desc: "Повторяющиеся вопросы уходят в базу знаний — наставники не отвлекаются на одно и то же.",
  },
  {
    icon: <GroupsOutlinedIcon />,
    title: "Единый стандарт",
    desc: "Одинаковое качество обучения для всей команды, независимо от офиса и наставника.",
  },
];

const USE_CASES = [
  {
    tag: "Сценарий",
    title: "Симуляция рабочих ситуаций",
    desc: "Продажник общается с клиентом, новичок проходит адаптацию — сотрудник выбирает действия и видит, к чему они приводят.",
  },
  {
    tag: "База знаний",
    title: "Ответы на частые вопросы",
    desc: "«Как оформить отпуск?», «Где взять шаблон?» — сотрудник выбирает вопрос в боте и сразу получает ответ.",
  },
  {
    tag: "Продажи",
    title: "Обучение продукту и скриптам",
    desc: "Интерактивные кейсы и справочные материалы для команды продаж.",
  },
  {
    tag: "Тренажёр",
    title: "Проверка знаний",
    desc: "Вопросы с вариантами ответов, обратная связь и аналитика по каждому сотруднику.",
  },
  {
    tag: "Compliance",
    title: "Регламенты и инструкции",
    desc: "Симуляции решений и быстрый доступ к правилам через базу знаний.",
  },
];

export default function MainPage() {
  return (
    <div className="landing landing--pattern">
      <section className="landing-hero landing-hero--mesh">
        <div className="landing-hero__content">
          <p className="landing-hero__badge landing-hero__badge--phrase">
            Обучение, база знаний и тренажёр в твоём кармане
          </p>
          <p className="landing-hero__channels">Доступно в Telegram и MAX</p>
          <div className="landing-hero__messengers">
            <MessengerBrandInline size={34} spaced />
          </div>
          <h1 className="landing-hero__title">MOGAME</h1>
          <p className="landing-hero__subtitle">
            MOGAME — помощник и подсказчик для вашей команды: интерактивное
            обучение, карманная база знаний с ответами в видео и тексте и
            тренажёр для прокачки навыков. Всё в привычном мессенджере — без
            отдельных приложений и сложной LMS.
          </p>
          <div className="landing-hero__actions">
            <Link to="/login?tab=register">
              <Button
                variant="contained"
                size="large"
                className="landing-hero__btn-primary"
              >
                Начать
              </Button>
            </Link>
            <Link to="/login">
              <Button
                variant="outlined"
                size="large"
                className="landing-hero__btn-secondary"
              >
                Войти
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <LandingProductsSection />

      <LandingProductDetailsSection />

      <section
        id="audience"
        className="landing-band landing-band--audience landing-section landing-section--audience"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="03 · Для кого"
            title="Кому подходит MOGAME"
            desc="Для тех, кто хочет быстрее обучать сотрудников, идти в ногу со временем и давать команде инструменты, которыми пользуются каждый день — а не пылятся на полке."
          />
          <div className="landing-band__panel landing-band__panel--audience">
            <div className="landing-audience landing-audience--single">
              <article className="landing-audience-card">
                <div className="landing-audience-card__icon">{AUDIENCE.icon}</div>
                <h3 className="landing-audience-card__title">{AUDIENCE.title}</h3>
                <p className="landing-audience-card__desc">{AUDIENCE.intro}</p>
                <div className="landing-audience-card__messengers">
                  <MessengerBrandInline size={30} />
                  <span>Обучение там, где уже общается команда</span>
                </div>
                <p className="landing-audience-card__subtitle">{AUDIENCE.subtitle}</p>
                <ul className="landing-audience-card__list landing-audience-card__list--audience">
                  {AUDIENCE.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </article>
            </div>
          </div>
        </div>
      </section>

      <section
        id="why"
        className="landing-band landing-band--why landing-section landing-section--benefits"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="04 · Преимущества"
            title="Почему это лучше классических инструкций и скучных видео"
            desc="Бумажные должностные инструкции лежат без дела, PDF никто не читает, а длинные записи перематывают. MOGAME даёт живое обучение, подсказки и проверку знаний там, где команда уже каждый день — в мессенджере."
          />
          <div className="landing-band__panel landing-band__panel--why">
            <div className="landing-benefits landing-benefits--five">
              {BENEFITS.map(({ icon, title, desc }) => (
                <article className="landing-benefit-card" key={title}>
                  <div className="landing-benefit-card__icon">{icon}</div>
                  <h3 className="landing-benefit-card__title">{title}</h3>
                  <p className="landing-benefit-card__desc">{desc}</p>
                </article>
              ))}
            </div>
            <div className="landing-outcomes">
              {OUTCOMES.map(({ icon, title, desc }) => (
                <article className="landing-outcome-card" key={title}>
                  <div className="landing-outcome-card__icon">{icon}</div>
                  <div>
                    <h3 className="landing-outcome-card__title">{title}</h3>
                    <p className="landing-outcome-card__desc">{desc}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <LandingMotivationSection />

      <LandingCreationSection />

      <section
        id="launch"
        className="landing-band landing-band--launch landing-section landing-section--steps"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="09 · Запуск"
            title="Четыре шага до программы в мессенджере"
            desc="От структуры сценария до доступа для команды — без программистов и сложных интеграций"
          />
          <div className="landing-band__panel landing-band__panel--launch">
            <div className="landing-launch">
            <div className="landing-launch__timeline">
              <CustomizedTimeline />
            </div>
            <aside className="landing-launch__aside">
              <div className="landing-video landing-launch__video">
                <video controls>
                  <source src="/video/main.mp4" type="video/webm" />
                </video>
              </div>
              <div className="landing-launch__highlights">
                <div className="landing-intro__highlight">
                  <strong>Интерактив</strong> — не PDF и не скучная запись
                </div>
                <div className="landing-intro__highlight landing-intro__highlight--messengers">
                  <span className="landing-intro__highlight-text">
                    <strong>Telegram или MAX</strong> — прохождение там, где люди
                    уже каждый день
                  </span>
                  <MessengerBrandStack size={30} />
                </div>
                <div className="landing-intro__highlight">
                  <strong>Без лишней возни</strong> — редактор, видео, ссылка
                  для команды, запуск
                </div>
              </div>
            </aside>
            </div>
          </div>
        </div>
      </section>

      <LandingAnalyticsSection />

      <section
        id="cases"
        className="landing-band landing-band--cases landing-section landing-section--usecases"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="11 · Примеры"
            title="Где MOGAME уже решает задачи"
            desc="Адаптация, продажи, compliance и поддержка команды — один инструмент под разные сценарии"
          />
          <div className="landing-band__panel landing-band__panel--cases">
            <div className="landing-usecases">
            {USE_CASES.map(({ tag, title, desc }) => (
              <article className="landing-usecase-card" key={title}>
                <span className="landing-usecase-card__tag">{tag}</span>
                <h3 className="landing-usecase-card__title">{title}</h3>
                <p className="landing-usecase-card__desc">{desc}</p>
              </article>
            ))}
            </div>
          </div>
        </div>
      </section>

      <section className="landing-cta">
        <h2 className="landing-cta__title">
          Запустите обучение, базу знаний или тренажёр для команды
        </h2>
        <div className="landing-cta__messengers">
          <MessengerBrandInline size={36} spaced />
        </div>
        <p className="landing-cta__desc">
          Создайте проект, оформите подписку и отправьте ссылку — команда получит
          обучение, подсказки и проверку знаний в Telegram или MAX.
        </p>
        <div className="landing-cta__actions">
          <Link to="/login?tab=register">
            <Button
              variant="contained"
              size="large"
              className="landing-hero__btn-primary"
            >
              Начать
            </Button>
          </Link>
          <Link to="/login">
            <Button
              variant="outlined"
              size="large"
              className="landing-hero__btn-secondary"
            >
              Уже есть аккаунт — войти
            </Button>
          </Link>
        </div>
      </section>

      <section
        id="faq"
        className="landing-band landing-band--faq landing-faq landing-section--faq"
      >
        <div className="landing-container">
          <LandingSectionHeader
            label="12 · Вопрос-ответ"
            title="Частые вопросы"
            desc="О платформе, подписке и запуске программ для команд"
          />
          <div className="landing-band__panel landing-band__panel--faq">
            <AccordionComponent />
          </div>
        </div>
      </section>

      <div className="footer">
        <div>
          <a
            href="/oferta"
            target="_blank"
            rel="noreferrer"
            style={{ color: "white" }}
          >
            Оферта
          </a>
        </div>
      </div>
    </div>
  );
}
